import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getMaterialsDictTreeApi, getMaterialsCalendarApi, getMaterialsByDateApi, postMaterialsDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    MaterialsData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    id: '',
    save: false,
}

/* 获取日历上的数据 */
export const getMaterialsDataCalendarAction = createAsyncThunk('MaterialsDataSlice/getMaterialsDataCalendarAction', async (params, thunkAPI) => {
    try {
        const result = await getMaterialsCalendarApi(params)
        return result?.data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据字典*/
export const getMaterialsDataDictDataAction = createAsyncThunk('MaterialsDataSlice/getMaterialsDataDictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getMaterialsDictTreeApi(dictType[0])
    return Promise.all([nameDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据 */
export const getMaterialsDataDataAction = createAsyncThunk('MaterialsDataSlice/getMaterialsDataDataAction', async (listDataParams, thunkAPI) => {
    try {
        const data = await getMaterialsByDateApi(listDataParams)
        return data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 保存数据 */
export const postMaterialsDataDataAction = createAsyncThunk('MaterialsDataSlice/postMaterialsDataDataAction', async (mmoObj, { dispatch }) => {
    try {
        await postMaterialsDataApi(mmoObj)
        return true // 已保存状态
    } catch (error) {
        dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 通过日期获取 id */
export const getMaterialsByDateAction = createAsyncThunk('MaterialsSlice/getMaterialsByDateAction', async (listDataParams, thunkAPI) => {
    try {
        const commentData = await getMaterialsByDateApi(listDataParams) // 通过日期查询 id
        return commentData?.data?.data?.id
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
}
)

export const MaterialsSlice = createSlice({
    name: 'MaterialsSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.MaterialsData = null
            state.calendarData = null
            state.save = false
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getMaterialsDataCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getMaterialsDataDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        // /* 通过日期，获取 回显数据 */
        [getMaterialsDataDataAction.fulfilled.type]: (state, action) => {
            state.MaterialsData = action.payload
            state.id = action.payload?.data?.id
        },

        /* 通过日期，获取 id */
        [getMaterialsByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
